// Définition de la langue par défaut
const defaultLanguage = "en";
const PLEDGE_API_URL = "https://script.google.com/macros/s/AKfycbwzO-q3a4UDBuD9Oy4duXx_wiiWguhz76I_F6-GCNKFty9z007ovHMNtxXYcT6Zm1okCA/exec";
const REQUIRED_UNSUBSCRIBE_ANONYMIZATION_MODE = "anonymous-values-v2";
// Fonction utilitaire pour obtenir la valeur d'un paramètre GET dans l'URL
const getUrlParameter = (name)=>new URLSearchParams(window.location.search).get(name);
// Fonction pour déterminer la langue courante
const getCurrentLanguage = ()=>{
    try {
        const urlLocale = getUrlParameter("defaultLocale");
        const urlForce = getUrlParameter("force");
        if (urlLocale && urlForce && typeof translations !== 'undefined' && translations[urlLocale.toLowerCase()] && "true" == urlForce.toLowerCase()) return urlLocale.toLowerCase();
    } catch (urlParameterForceException) {
        console.error("Error while checking defaultLanguage and force in URL", urlParameterForceException);
    }
    try {
        const browserLang = (navigator.language || navigator.userLanguage).slice(0, 2).toLowerCase();
        if (typeof translations !== 'undefined' && translations[browserLang]) return browserLang;
    } catch (detectionException) {
        console.error("Error while detecting browser language", detectionException);
    }
    try {
        const urlLocale = getUrlParameter("defaultLocale");
        if (urlLocale && typeof translations !== 'undefined' && translations[urlLocale.toLowerCase()]) return urlLocale.toLowerCase();
    } catch (urlParameterException) {
        console.error("Error while checking defaultLanguage in URL", urlParameterException);
    }
    return defaultLanguage;
};
const getTranslation = (key, fallback)=>{
    const language = getCurrentLanguage();
    if (typeof translations !== 'undefined' && translations[language] && translations[language][key]) return translations[language][key];
    if (typeof translations !== 'undefined' && translations[defaultLanguage] && translations[defaultLanguage][key]) return translations[defaultLanguage][key];
    return fallback || key;
};
const getUnsubscribeTarget = ()=>{
    const target = (getUrlParameter("target") || "").trim().toLowerCase();
    return target === "dadd" ? "dadd" : "padd";
};
const getLogoSource = (target)=>{
    if (target === "dadd") return getTranslation("home-dadd-logo", "/images/dadd-logo-en.png");
    return getTranslation("home-padd-logo", "/images/padd-logo-en.png");
};
const applyUnsubscribeTargetLogo = ()=>{
    const logo = document.getElementById("unsubscribeLogo");
    if (!logo) return;
    const target = getUnsubscribeTarget();
    logo.src = getLogoSource(target);
    logo.alt = target === "dadd" ? "DADD - Doctors Against Drowsy Driving" : "PADD - Pharmacists Against Drowsy Driving";
};
let unsubscribeEndpointSupported = false;
const ensureUnsubscribeEndpointSupported = ()=>{
    if (unsubscribeEndpointSupported) return Promise.resolve();
    return fetch(`${PLEDGE_API_URL}?method=unsubscribeHealth`).then((response)=>response.json()).then((data)=>{
        if (!data || data.unsubscribe !== true || data.anonymizationMode !== REQUIRED_UNSUBSCRIBE_ANONYMIZATION_MODE) throw new Error(`unsubscribe_mode_mismatch:${data && data.anonymizationMode ? data.anonymizationMode : "missing"}`);
        unsubscribeEndpointSupported = true;
    });
};
// Fonction qui applique la traduction à un élément en fonction de son type
function localizeElement(el, translation) {
    const tag = el.tagName.toLowerCase();
    if (tag === "img") {
        // Pour les images, on met à jour l'attribut src
        el.src = translation;
        // Optionnel : on peut aussi mettre à jour alt si besoin
        if (translations[getCurrentLanguage()] && translations[getCurrentLanguage()][tag + "-alt"]) el.alt = translations[getCurrentLanguage()][tag + "-alt"];
    }
    if (tag === "link") // Pour les images, on met à jour l'attribut src
    el.href = translation;
    if (tag === "iframe") {
        console.log("localizeElement avant localisation:", el.src, " apres localisation:", translation);
        el.src = translation;
    } else // Pour les autres éléments, on remplace tout le contenu
    el.innerHTML = translation;
}
// Fonction de localisation qui applique les traductions aux éléments de la page
const localizePage = ()=>{
    const currentLang = getCurrentLanguage();
    document.querySelector("html").setAttribute("lang", currentLang);
    console.log("localizePage", translations, translations[currentLang]);
    document.querySelectorAll('[data-i18n]').forEach((el)=>{
        const key = el.getAttribute('data-i18n');
        if (translations[currentLang] && translations[currentLang][key]) localizeElement(el, translations[currentLang][key]);
        else console.warn(`Traduction manquante pour la cl\xe9 "${key}" en "${currentLang}"`);
        const hrefKey = el.getAttribute('data-i18n-href');
        if (hrefKey) {
            if (translations[currentLang] && translations[currentLang][hrefKey]) el.setAttribute('href', translations[currentLang][hrefKey]);
            else console.warn(`Traduction manquante pour la cl\xe9 d'href "${hrefKey}" en "${currentLang}"`);
        }
    });
    document.querySelector("html").style.opacity = 1;
};
document.addEventListener('DOMContentLoaded', localizePage);
document.addEventListener('DOMContentLoaded', applyUnsubscribeTargetLogo);
// ======= Population Dynamique des Pays =======
// Nouvelle structure pour les pays par langue
const countriesByLang = {
    en: [
        "Afghanistan",
        "South Africa",
        "Albania",
        "Algeria",
        "Germany",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Saudi Arabia",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Belarus",
        "Myanmar",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Cyprus",
        "Colombia",
        "Comoros",
        "Republic of the Congo",
        "Democratic Republic of the Congo",
        "North Korea",
        "South Korea",
        "Costa Rica",
        "Ivory Coast",
        "Croatia",
        "Cuba",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Egypt",
        "El Salvador",
        "United Arab Emirates",
        "Ecuador",
        "Eritrea",
        "Spain",
        "Estonia",
        "United States",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Equatorial Guinea",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "India",
        "Indonesia",
        "Iraq",
        "Iran",
        "Ireland",
        "Iceland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kyrgyzstan",
        "Kiribati",
        "Kuwait",
        "Laos",
        "Lesotho",
        "Latvia",
        "Lebanon",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "North Macedonia",
        "Madagascar",
        "Malaysia",
        "Malawi",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "New Zealand",
        "Oman",
        "Uganda",
        "Uzbekistan",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Netherlands",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Dominican Republic",
        "Romania",
        "United Kingdom",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Solomon Islands",
        "Samoa",
        "Sao Tome and Principe",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Somalia",
        "Sudan",
        "South Sudan",
        "Sri Lanka",
        "Sweden",
        "Switzerland",
        "Suriname",
        "Eswatini",
        "Syria",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkmenistan",
        "Turkey",
        "Tuvalu",
        "Ukraine",
        "Uruguay",
        "Vanuatu",
        "Vatican City",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ],
    fr: [
        "Afghanistan",
        "Afrique du Sud",
        "Albanie",
        "Alg\xe9rie",
        "Allemagne",
        "Andorre",
        "Angola",
        "Antigua-et-Barbuda",
        "Arabie saoudite",
        "Argentine",
        "Arm\xe9nie",
        "Australie",
        "Autriche",
        "Azerba\xefdjan",
        "Bahamas",
        "Bahre\xefn",
        "Bangladesh",
        "Barbade",
        "Belgique",
        "Belize",
        "B\xe9nin",
        "Bhoutan",
        "Bi\xe9lorussie",
        "Birmanie",
        "Bolivie",
        "Bosnie-Herz\xe9govine",
        "Botswana",
        "Br\xe9sil",
        "Brun\xe9i",
        "Bulgarie",
        "Burkina Faso",
        "Burundi",
        "Cambodge",
        "Cameroun",
        "Canada",
        "Cap-Vert",
        "R\xe9publique centrafricaine",
        "Tchad",
        "Chili",
        "Chine",
        "Chypre",
        "Colombie",
        "Comores",
        "R\xe9publique du Congo",
        "R\xe9publique d\xe9mocratique du Congo",
        "Cor\xe9e du Nord",
        "Cor\xe9e du Sud",
        "Costa Rica",
        "C\xf4te d'Ivoire",
        "Croatie",
        "Cuba",
        "Danemark",
        "Djibouti",
        "Dominique",
        "\xc9gypte",
        "Salvador",
        "\xc9mirats arabes unis",
        "\xc9quateur",
        "\xc9rythr\xe9e",
        "Espagne",
        "Estonie",
        "\xc9tats-Unis",
        "\xc9thiopie",
        "Fidji",
        "Finlande",
        "France",
        "Gabon",
        "Gambie",
        "G\xe9orgie",
        "Ghana",
        "Gr\xe8ce",
        "Grenade",
        "Guatemala",
        "Guin\xe9e",
        "Guin\xe9e-Bissau",
        "Guin\xe9e \xe9quatoriale",
        "Guyana",
        "Ha\xefti",
        "Honduras",
        "Hongrie",
        "Inde",
        "Indon\xe9sie",
        "Irak",
        "Iran",
        "Irlande",
        "Islande",
        "Isra\xebl",
        "Italie",
        "Jama\xefque",
        "Japon",
        "Jordanie",
        "Kazakhstan",
        "Kenya",
        "Kirghizistan",
        "Kiribati",
        "Kowe\xeft",
        "Laos",
        "Lesotho",
        "Lettonie",
        "Liban",
        "Lib\xe9ria",
        "Libye",
        "Liechtenstein",
        "Lituanie",
        "Luxembourg",
        "Mac\xe9doine du Nord",
        "Madagascar",
        "Malaisie",
        "Malawi",
        "Maldives",
        "Mali",
        "Malte",
        "\xceles Marshall",
        "Mauritanie",
        "Maurice",
        "Mexique",
        "Micron\xe9sie",
        "Moldavie",
        "Monaco",
        "Mongolie",
        "Mont\xe9n\xe9gro",
        "Maroc",
        "Mozambique",
        "Namibie",
        "Nauru",
        "N\xe9pal",
        "Nicaragua",
        "Niger",
        "Nig\xe9ria",
        "Norv\xe8ge",
        "Nouvelle-Z\xe9lande",
        "Oman",
        "Ouganda",
        "Ouzb\xe9kistan",
        "Pakistan",
        "Palaos",
        "Panama",
        "Papouasie-Nouvelle-Guin\xe9e",
        "Paraguay",
        "Pays-Bas",
        "P\xe9rou",
        "Philippines",
        "Pologne",
        "Portugal",
        "Qatar",
        "R\xe9publique dominicaine",
        "Roumanie",
        "Royaume-Uni",
        "Russie",
        "Rwanda",
        "Saint-Christophe-et-Ni\xe9v\xe8s",
        "Sainte-Lucie",
        "Saint-Vincent-et-les Grenadines",
        "\xceles Salomon",
        "Samoa",
        "Sao Tom\xe9-et-Principe",
        "S\xe9n\xe9gal",
        "Serbie",
        "Seychelles",
        "Sierra Leone",
        "Singapour",
        "Slovaquie",
        "Slov\xe9nie",
        "Somalie",
        "Soudan",
        "Soudan du Sud",
        "Sri Lanka",
        "Su\xe8de",
        "Suisse",
        "Suriname",
        "Eswatini",
        "Syrie",
        "Tadjikistan",
        "Tanzanie",
        "Tha\xeflande",
        "Timor oriental",
        "Togo",
        "Tonga",
        "Trinit\xe9-et-Tobago",
        "Tunisie",
        "Turkm\xe9nistan",
        "Turquie",
        "Tuvalu",
        "Ukraine",
        "Uruguay",
        "Vanuatu",
        "Vatican",
        "Venezuela",
        "Vi\xeat Nam",
        "Y\xe9men",
        "Zambie",
        "Zimbabwe"
    ],
    es: [
        "Afganist\xe1n",
        "Sud\xe1frica",
        "Albania",
        "Argelia",
        "Alemania",
        "Andorra",
        "Angola",
        "Antigua y Barbuda",
        "Arabia Saudita",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaiy\xe1n",
        "Bahamas",
        "Bar\xe9in",
        "Bangladesh",
        "Barbados",
        "B\xe9lgica",
        "Belice",
        "Ben\xedn",
        "But\xe1n",
        "Bielorrusia",
        "Birmania",
        "Bolivia",
        "Bosnia y Herzegovina",
        "Botsuana",
        "Brasil",
        "Brun\xe9i",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Camboya",
        "Camer\xfan",
        "Canad\xe1",
        "Cabo Verde",
        "Rep\xfablica Centroafricana",
        "Chad",
        "Chile",
        "China",
        "Chipre",
        "Colombia",
        "Comoras",
        "Congo (Rep\xfablica)",
        "Congo (R. D.)",
        "Corea del Norte",
        "Corea del Sur",
        "Costa Rica",
        "Costa de Marfil",
        "Croacia",
        "Cuba",
        "Dinamarca",
        "Yibuti",
        "Dominica",
        "Egipto",
        "El Salvador",
        "Emiratos \xc1rabes Unidos",
        "Ecuador",
        "Eritrea",
        "Espa\xf1a",
        "Estonia",
        "Estados Unidos",
        "Etiop\xeda",
        "Fiyi",
        "Finlandia",
        "Francia",
        "Gab\xf3n",
        "Gambia",
        "Georgia",
        "Ghana",
        "Grecia",
        "Granada",
        "Guatemala",
        "Guinea",
        "Guinea-Bis\xe1u",
        "Guinea Ecuatorial",
        "Guyana",
        "Hait\xed",
        "Honduras",
        "Hungr\xeda",
        "India",
        "Indonesia",
        "Irak",
        "Ir\xe1n",
        "Irlanda",
        "Islandia",
        "Israel",
        "Italia",
        "Jamaica",
        "Jap\xf3n",
        "Jordania",
        "Kazajist\xe1n",
        "Kenia",
        "Kirguist\xe1n",
        "Kiribati",
        "Kuwait",
        "Laos",
        "Lesoto",
        "Letonia",
        "L\xedbano",
        "Liberia",
        "Libia",
        "Liechtenstein",
        "Lituania",
        "Luxemburgo",
        "Macedonia del Norte",
        "Madagascar",
        "Malasia",
        "Malaui",
        "Maldivas",
        "Mal\xed",
        "Malta",
        "Islas Marshall",
        "Mauritania",
        "Mauricio",
        "M\xe9xico",
        "Micronesia",
        "Moldavia",
        "M\xf3naco",
        "Mongolia",
        "Montenegro",
        "Marruecos",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Nicaragua",
        "N\xedger",
        "Nigeria",
        "Noruega",
        "Nueva Zelanda",
        "Om\xe1n",
        "Uganda",
        "Uzbekist\xe1n",
        "Pakist\xe1n",
        "Palaos",
        "Panam\xe1",
        "Pap\xfaa Nueva Guinea",
        "Paraguay",
        "Pa\xedses Bajos",
        "Per\xfa",
        "Filipinas",
        "Polonia",
        "Portugal",
        "Catar",
        "Rep\xfablica Dominicana",
        "Ruman\xeda",
        "Reino Unido",
        "Rusia",
        "Ruanda",
        "San Crist\xf3bal y Nieves",
        "Santa Luc\xeda",
        "San Vicente y las Granadinas",
        "Islas Salom\xf3n",
        "Samoa",
        "Santo Tom\xe9 y Pr\xedncipe",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leona",
        "Singapur",
        "Eslovaquia",
        "Eslovenia",
        "Somalia",
        "Sud\xe1n",
        "Sud\xe1n del Sur",
        "Sri Lanka",
        "Suecia",
        "Suiza",
        "Surinam",
        "Esuatini",
        "Siria",
        "Tayikist\xe1n",
        "Tanzania",
        "Tailandia",
        "Timor Oriental",
        "Togo",
        "Tonga",
        "Trinidad y Tobago",
        "T\xfanez",
        "Turkmenist\xe1n",
        "Turqu\xeda",
        "Tuvalu",
        "Ucrania",
        "Uruguay",
        "Vanuatu",
        "Ciudad del Vaticano",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabue"
    ],
    pt: [
        "Afeganist\xe3o",
        "\xc1frica do Sul",
        "Alb\xe2nia",
        "Arg\xe9lia",
        "Alemanha",
        "Andorra",
        "Angola",
        "Ant\xedgua e Barbuda",
        "Ar\xe1bia Saudita",
        "Argentina",
        "Arm\xe9nia",
        "Austr\xe1lia",
        "\xc1ustria",
        "Azerbaij\xe3o",
        "Bahamas",
        "Bahrein",
        "Bangladesh",
        "Barbados",
        "B\xe9lgica",
        "Belize",
        "Benim",
        "But\xe3o",
        "Bielorr\xfassia",
        "Myanmar",
        "Bol\xedvia",
        "B\xf3snia e Herzegovina",
        "Botswana",
        "Brasil",
        "Brunei",
        "Bulg\xe1ria",
        "Burquina Faso",
        "Bur\xfandi",
        "Camboja",
        "Camar\xf5es",
        "Canad\xe1",
        "Cabo Verde",
        "Rep\xfablica Centro-Africana",
        "Chade",
        "Chile",
        "China",
        "Chipre",
        "Col\xf4mbia",
        "Comores",
        "Rep\xfablica do Congo",
        "Rep\xfablica Democr\xe1tica do Congo",
        "Coreia do Norte",
        "Coreia do Sul",
        "Costa Rica",
        "Costa do Marfim",
        "Cro\xe1cia",
        "Cuba",
        "Dinamarca",
        "Djibuti",
        "Dominica",
        "Egito",
        "El Salvador",
        "Emirados \xc1rabes Unidos",
        "Equador",
        "Eritreia",
        "Espanha",
        "Est\xf3nia",
        "Estados Unidos",
        "Eti\xf3pia",
        "Fiji",
        "Finl\xe2ndia",
        "Fran\xe7a",
        "Gab\xe3o",
        "G\xe2mbia",
        "Ge\xf3rgia",
        "Gana",
        "Gr\xe9cia",
        "Granada",
        "Guatemala",
        "Guin\xe9",
        "Guin\xe9-Bissau",
        "Guin\xe9 Equatorial",
        "Guiana",
        "Haiti",
        "Honduras",
        "Hungria",
        "\xcdndia",
        "Indon\xe9sia",
        "Iraque",
        "Ir\xe3o",
        "Irlanda",
        "Isl\xe2ndia",
        "Israel",
        "It\xe1lia",
        "Jamaica",
        "Jap\xe3o",
        "Jord\xe2nia",
        "Cazaquist\xe3o",
        "Qu\xe9nia",
        "Quirguist\xe3o",
        "Quirib\xe1ti",
        "Kuwait",
        "Laos",
        "Lesoto",
        "Let\xf3nia",
        "L\xedbano",
        "Lib\xe9ria",
        "L\xedbia",
        "Liechtenstein",
        "Litu\xe2nia",
        "Luxemburgo",
        "Maced\xf3nia do Norte",
        "Madag\xe1scar",
        "Mal\xe1sia",
        "Malawi",
        "Maldivas",
        "Mali",
        "Malta",
        "Ilhas Marshall",
        "Maurit\xe2nia",
        "Maur\xedcia",
        "M\xe9xico",
        "Micron\xe9sia",
        "Mold\xe1via",
        "M\xf3naco",
        "Mong\xf3lia",
        "Montenegro",
        "Marrocos",
        "Mo\xe7ambique",
        "Nam\xedbia",
        "Nauru",
        "Nepal",
        "Nicar\xe1gua",
        "N\xedger",
        "Nig\xe9ria",
        "Noruega",
        "Nova Zel\xe2ndia",
        "Om\xe3",
        "Uganda",
        "Uzbequist\xe3o",
        "Paquist\xe3o",
        "Palau",
        "Panam\xe1",
        "Papua Nova Guin\xe9",
        "Paraguai",
        "Pa\xedses Baixos",
        "Peru",
        "Filipinas",
        "Pol\xf3nia",
        "Portugal",
        "Qatar",
        "Rep\xfablica Dominicana",
        "Rom\xe9nia",
        "Reino Unido",
        "R\xfassia",
        "Ruanda",
        "S\xe3o Crist\xf3v\xe3o e Neves",
        "S\xe3o L\xfacia",
        "S\xe3o Vicente e Granadinas",
        "Ilhas Salom\xe3o",
        "Samoa",
        "S\xe3o Tom\xe9 e Pr\xedncipe",
        "Senegal",
        "S\xe9rvia",
        "Seicheles",
        "Serra Leoa",
        "Singapura",
        "Eslov\xe1quia",
        "Eslov\xe9nia",
        "Som\xe1lia",
        "Sud\xe3o",
        "Sud\xe3o do Sul",
        "Sri Lanka",
        "Su\xe9cia",
        "Su\xed\xe7a",
        "Suriname",
        "Essuat\xedni",
        "S\xedria",
        "Tajiquist\xe3o",
        "Tanz\xe2nia",
        "Tail\xe2ndia",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trindade e Tobago",
        "Tun\xedsia",
        "Turquemenist\xe3o",
        "Turquia",
        "Tuvalu",
        "Ucr\xe2nia",
        "Uruguai",
        "Vanuatu",
        "Cidade do Vaticano",
        "Venezuela",
        "Vietname",
        "I\xe9men",
        "Z\xe2mbia",
        "Zimb\xe1bue"
    ]
};
// Fonction utilitaire pour obtenir la langue courante (déjà défini plus haut)
// const getCurrentLanguage = () => { ... }
function getCountries() {
    const lang1 = getCurrentLanguage();
    // fallback: en
    return countriesByLang[lang1] || countriesByLang["en"];
}
// ======= Listes dépendantes de la langue =======
const prioritizedCountriesByLang = {
    en: [
        "United Kingdom",
        "United States"
    ],
    fr: [
        "France",
        "Canada"
    ],
    es: [
        "Colombia",
        "Costa Rica"
    ],
    pt: [
        "Brasil",
        "Portugal"
    ]
};
const titlesByLang = {
    en: [
        "Dr",
        "Prof."
    ],
    fr: [
        "Dr",
        "Pr"
    ],
    es: [
        "Dra",
        "Dr",
        "Prof."
    ],
    pt: [
        "Dr.",
        "Prof"
    ]
};
const titlesByLangForPADD = {
    en: [
        "Mr.",
        "Ms."
    ],
    fr: [
        "M.",
        "Mme"
    ],
    es: [
        "Sr.",
        "Sra."
    ]
};
const getPrioritizedCountries = (lang1 = getCurrentLanguage())=>(prioritizedCountriesByLang[lang1] || prioritizedCountriesByLang.en).slice();
const getTitles = (lang1 = getCurrentLanguage(), platform = getPlatform())=>platform == "dadd" ? (titlesByLang[lang1] || titlesByLang.en).slice() : (titlesByLangForPADD[lang1] || titlesByLangForPADD.en).slice();
function populateCountries() {
    const select = document.getElementById('pays');
    if (!select) return;
    const allCountries = getCountries();
    const prioritizedCountries = getPrioritizedCountries();
    const sortedCountries = allCountries.slice().sort((a, b)=>a.localeCompare(b, getCurrentLanguage()));
    const remainingCountries = sortedCountries.filter((c)=>!prioritizedCountries.includes(c));
    const finalList = [
        ...prioritizedCountries,
        ...remainingCountries
    ];
    finalList.forEach((country)=>{
        const option = document.createElement('option');
        option.value = country;
        option.innerText = country;
        select.appendChild(option);
    });
}
document.addEventListener('DOMContentLoaded', populateCountries);
function populateTitles() {
    const select = document.getElementById('titre');
    if (!select) return;
    const titles = getTitles();
    titles.forEach((title)=>{
        const option = document.createElement('option');
        option.value = title;
        option.innerText = title;
        select.appendChild(option);
    });
}
document.addEventListener('DOMContentLoaded', populateTitles);
// ======= Désactiver/Réactiver le scroll global =======
function disableScroll() {
    document.body.style.overflow = 'hidden';
}
function enableScroll() {
    document.body.style.overflow = '';
}
// ======= Fonctions d'Affichage (Loader, Popup) =======
function showLoader(show) {
    const overlay = document.getElementById('loaderOverlay');
    if (overlay) overlay.style.display = show ? "flex" : "none";
    if (show) disableScroll();
    else enableScroll();
}
function showPopup(message) {
    const popupModal = document.getElementById('popupModal');
    const popupMessage = document.getElementById('popupMessage');
    popupMessage.innerText = message;
    popupModal.style.display = "flex";
    disableScroll();
}
let closePopup = document.getElementById('closePopup');
if (closePopup) closePopup.addEventListener('click', ()=>{
    document.getElementById('popupModal').style.display = "none";
    enableScroll();
});
// ======= Détection de la plateforme (dadd / padd) =======
function getPlatform() {
    const filename = window.location.pathname.split('/').pop().toLowerCase();
    if (filename.includes('padd')) return 'padd';
    return 'dadd';
}
// ======= Validation & Soumission du Formulaire (x-www-form-urlencoded) =======
const form = document.getElementById('pledgeForm');
if (form) form.addEventListener('submit', (e)=>{
    e.preventDefault();
    const language = getCurrentLanguage();
    const regexName = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
    const regexEmail = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
    const titre = document.getElementById('titre').value;
    const nom = document.getElementById('nom').value.trim();
    const prenom = document.getElementById('prenom').value.trim();
    const email = document.getElementById('email').value.trim();
    const pays = document.getElementById('pays').value;
    const sign = document.getElementById('sign').checked;
    const acceptTerms = true; //document.getElementById('acceptTerms').checked;
    // Validation
    if (!regexName.test(nom)) {
        showPopup(translations[lang].invalidName);
        return;
    }
    if (titre === "") {
        showPopup(translations[lang].invalidTitre);
        return;
    }
    if (!regexName.test(prenom)) {
        showPopup(translations[lang].invalidPrenom);
        return;
    }
    if (!regexEmail.test(email)) {
        showPopup(translations[lang].invalidEmail);
        return;
    }
    if (pays === "") {
        showPopup(translations[lang].invalidPays);
        return;
    }
    if (!sign) {
        showPopup(translations[lang].signatureMissing);
        return;
    }
    if (!acceptTerms) {
        showPopup(translations[lang].invalidAcceptTerms);
        return;
    }
    showLoader(true);
    const params = new URLSearchParams();
    params.append('language', language);
    params.append('platform', getPlatform());
    params.append('titre', titre);
    params.append('nom', nom);
    params.append('prenom', prenom);
    params.append('email', email);
    params.append('pays', pays);
    params.append('signature', sign);
    params.append('acceptTerms', acceptTerms);
    console.log(params.toString());
    fetch(PLEDGE_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
    }).then((response)=>response.json()).then((result)=>{
        showLoader(false);
        if (result.success) {
            showPopup(translations[language].successMessage);
            form.reset();
        } else showPopup(translations[language].errorMessage);
    }).catch((error)=>{
        console.error('Erreur:', error);
        showLoader(false);
        showPopup(translations[language].errorMessage);
    });
});
const unsubscribeForm = document.getElementById('unsubscribeForm');
if (unsubscribeForm) unsubscribeForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    const language = getCurrentLanguage();
    const regexEmail = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/;
    const emailInput = document.getElementById('unsubscribeEmail');
    const email = emailInput ? emailInput.value.trim() : "";
    if (!regexEmail.test(email)) {
        showPopup(getTranslation('unsubscribe-invalid-email', 'Please enter a valid email address.'));
        return;
    }
    showLoader(true);
    const params = new URLSearchParams();
    params.append('action', 'unsubscribe');
    params.append('email', email);
    params.append('language', language);
    ensureUnsubscribeEndpointSupported().then(()=>fetch(PLEDGE_API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        })).catch((error)=>{
        console.error("Erreur d\xe9sinscription:", error);
    }).finally(()=>{
        showLoader(false);
        showPopup(getTranslation('unsubscribe-success-message', 'Your request has been taken into account.'));
        unsubscribeForm.reset();
    });
});
function updateCounter(localUpdate) {
    if (localUpdate) displayCounter();
    else fetch(`${PLEDGE_API_URL}?method=pledgeCount`).then((response)=>response.json()).then((data)=>{
        console.log('data:', data);
        const daddCount = data.daddPledgeCount;
        const paddCount = data.paddPledgeCount;
        localStorage.setItem("daad::pledgeCount", daddCount);
        localStorage.setItem("paad::pledgeCount", paddCount);
        displayCounter();
    }).catch((error)=>{
        console.error('Error fetching counter:', error);
    });
}
function displayCounter() {
    let counterContainer = document.querySelector('.counter-container');
    let shouldAddDADDParticipants = "true" === counterContainer.getAttribute("data-dadd");
    let shouldAddPADDParticipants = "true" === counterContainer.getAttribute("data-padd");
    let daddValue = parseInt(localStorage.getItem("daad::pledgeCount")) || 0;
    let paddValue = parseInt(localStorage.getItem("paad::pledgeCount")) || 0;
    console.log("displayCounter", shouldAddDADDParticipants, shouldAddPADDParticipants, daddValue, paddValue);
    let value = 0;
    if (shouldAddDADDParticipants) value += daddValue;
    if (shouldAddPADDParticipants) value += paddValue;
    const countStr = String(value).padStart(4, '0');
    document.querySelector('.counter-container').classList.remove("faded");
    const symbols = document.querySelectorAll('.counter-symbol');
    symbols.forEach((elem, index)=>{
        elem.innerText = countStr.charAt(index) || '';
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    if (null != document.querySelector('.counter-container')) {
        updateCounter(true);
        updateCounter();
        setInterval(updateCounter, 30000);
    }
});
document.addEventListener('DOMContentLoaded', ()=>{
    // Récupère les paramètres de l'URL actuelle (incluant le "?" s'ils existent)
    const currentParams = window.location.search;
    // Parcourt tous les liens
    document.querySelectorAll('a[href]').forEach((anchor)=>{
        let href = anchor.getAttribute('href');
        // Vérifie que le lien est interne (ne commence pas par http://, https:// ou //) et qu'il ne s'agit pas d'un lien ancre (#)
        if (!/^(?:[a-z]+:)?\/\//i.test(href) && !/^[a-z]+:/i.test(href) && href.charAt(0) !== '#') {
            // Crée une URL en se basant sur l'origine actuelle
            const url = new URL(href, window.location.origin);
            const isUnsubscribeLink = url.pathname.endsWith('/unsubscribe.html');
            if (!currentParams && !isUnsubscribeLink) return;
            // Si l'URL du lien a déjà des paramètres, on fusionne
            const linkParams = new URLSearchParams(url.search);
            const currentSearchParams = new URLSearchParams(currentParams);
            currentSearchParams.forEach((value, key)=>{
                // Remplace ou ajoute le paramètre
                linkParams.set(key, value);
            });
            if (isUnsubscribeLink && !linkParams.has('target')) linkParams.set('target', getPlatform());
            // Met à jour l'URL du lien avec le nouveau search string
            url.search = linkParams.toString();
            // Met à jour l'attribut href avec le nouveau chemin complet
            anchor.setAttribute('href', url.pathname + url.search + url.hash);
        }
    });
});

//# sourceMappingURL=index.deb54863.js.map
